export default "__VITE_ASSET__3N565LQl__"